import React from "react";
import { Link } from 'react-router-dom';
import { Routes, Route } from "react-router-dom";
import Optout from "./OptoutTop/OptoutTop";
import Inquiry from "./Inquiry/Inquiry.tsx";
import InquiryComplete from "./Complete/InquiryComplete";
import SubmitComplete from "./Complete/SubmitComplete";
import OptoutComplete from "./Complete/OptoutComplete";
import OptoutConfirm from "./Confirm/OptoutConfirm";
import SubmitErrorOptout from "./Error/SubmitErrorOptout";
import SubmitErrorQuit from "./Error/SubmitErrorQuit";
import SubmitNotFoundEmail from "./Error/SubmitNotFoundEmail";
import UnexpectedError from "./Error/UnexpectedError";
import TokenError from "./Error/TokenError";

const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<Optout />} />
    <Route path="/optout" element={<Optout />} />
    <Route path="/inquiry" element={<Inquiry />} />
    <Route path="/InquiryComplete" element={<InquiryComplete />} />
    <Route path="/SubmitComplete" element={<SubmitComplete />} />
    <Route path="/OptoutComplete" element={<OptoutComplete />} />
    <Route path="/OptoutConfirm" element={<OptoutConfirm />} />
    <Route path="/SubmitErrorOptout" element={<SubmitErrorOptout />} />
    <Route path="/SubmitErrorQuit" element={<SubmitErrorQuit />} />
    <Route path="/SubmitNotFoundEmail" element={<SubmitNotFoundEmail />} />
    <Route path="/UnexpectedError" element={<UnexpectedError />} />
    <Route path="/TokenError" element={<TokenError />} />
    <Route path="*" element={<NotFound />} />
  </Routes>
);

const NotFound = () => (
  <div>
    <h2>ページが見つかりません</h2>
    <Link to="/">ホームに戻る</Link>
  </div>
);

export default AppRoutes;
